import Vue from "vue";
import ToastVue from "./Index.vue";
import PopPlugins from "@/utils/popPlugins";

const ToastConstructor = Vue.extend(ToastVue);
let timeout = null;

class Toast extends PopPlugins {
	constructor(name, vueConstructor, options) {
		super(name, vueConstructor, options);
	}
	show(msg, cb = () => {}) {
		this.instance.msg = msg;
		this.instance.cb = cb;
		super.show();
		if (timeout != null) {
			clearTimeout(timeout);
			timeout = null;
		}
		timeout = setTimeout(() => {
			this.hide();
		}, 3000);
	}
	hide() {
		super.hide();
		this.instance.cb && this.instance.cb();
	}
}
const instance = new Toast("Toast", ToastConstructor);

export default {
	install(Vue) {
		Vue.prototype.$toast = instance;
	},
};

export { instance };
